export default "__VITE_ASSET__CaLAlVlk__"